import dynamic from 'next/dynamic';

import { Link } from '@mui/material';

import HoverCopyCell from '@/components/table-data-grid/HoverCopyCell';
import { dateUtils } from '@/utils/date';
import { t } from '@/utils/lang';

const EntityDetailButton = dynamic(
    () => import('@/components/entity-detail/components/Button'),
    {
        ssr: false,
    }
);

export const columns = (columnParams?: any) => [
    {
        field: 'fullname',
        headerName: 'Họ và tên',
        editable: false,
        sortable: false,
        minWidth: 150,
        flex: 1,
        renderCell: params => (
            <HoverCopyCell value={params.row.fullname}>
                <EntityDetailButton
                    text={params.row.fullname}
                    identifier={columnParams?.identifier}
                    entityId={params.row.id}
                    type='ASSIGNEE'
                />
            </HoverCopyCell>
        ),
    },
    {
        field: 'username',
        headerName: 'Tài khoản',
        editable: false,
        sortable: false,
        minWidth: 150,
        flex: 1,
        renderCell: params => <HoverCopyCell value={params.row.userName} />,
    },
    {
        field: 'email',
        headerName: 'Email',
        editable: false,
        sortable: false,
        minWidth: 200,
        flex: 1,
        renderCell: params => <HoverCopyCell value={params.row.email} />,
    },
    {
        field: 'position',
        headerName: 'Vị trí',
        editable: false,
        sortable: false,
        minWidth: 250,
        flex: 1,
        renderCell: params => <HoverCopyCell value={params.row.position} />,
    },
    {
        field: 'function',
        headerName: 'Chức năng',
        editable: false,
        sortable: false,
        flex: 1,
        minWidth: 200,
        renderCell: params => (
            <Link
                component='span'
                underline='hover'
                variant='body2'
                onClick={e => {
                    e.stopPropagation();
                    columnParams.rolePermissionDialogRef.current?.setUserData(
                        params.row
                    );
                    columnParams.rolePermissionDialogRef.current?.handleClickOpen();
                }}
            >
                {t('Sửa và chọn vai trò')}
            </Link>
        ),
    },
    {
        field: 'createdDate',
        headerName: 'Ngày tạo',
        editable: false,
        sortable: true,
        minWidth: 200,
        flex: 1,
        sortingOrder: ['asc', 'desc'],
        renderCell: params => (
            <HoverCopyCell
                value={dateUtils.getDateTimeLocal(
                    params.row.createdDate,
                    dateUtils.defaultDatetimeFormatWithoutSeconds
                )}
            />
        ),
    },
];
